<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        class="centerPlace"
      >
        <v-card elevation="12" class="rounded-xl auth-glass-card" :loading="sending">
          <v-toolbar
            color="transparent"
            flat
            height="64"
            class="px-2"
          >
            <v-toolbar-title class="font-weight-bold">
              <div class="d-flex align-center">
                <v-img
                  :src="logo"
                  width="40"
                  height="40"
                  max-width="40"
                  class="mr-2 flex-grow-0 flex-shrink-0"
                />
                <span>Mot de passe oublié</span>
              </div>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-alert
              v-if="displayConfirm"
              color="primary"
              border="start"
              border-color
              elevation="2"
              class="mb-3"
            >
              Vous allez recevoir un email pour terminer la procédure de réinitialisation
            </v-alert>
            <v-form>
              <div class="mb-1 px-1">
                <label for="username" class="text-body-2 font-weight-medium">Email</label>
              </div>
              <v-text-field
                id="username"
                v-model="username"
                name="username"
                placeholder="exemple@email.com"
                prepend-inner-icon="mdi-account"
                type="text"
                autocomplete="username"
                class="mb-3"
                bg-color="background"
                @keydown.enter="renew"
              />
            </v-form>

            <v-row dense class="mt-2 text-center">
              <v-col cols="12">
                <v-btn
                  color="primary"
                  size="large"
                  block
                  :loading="sending"
                  @click="renew"
                >
                  Envoyer les instructions
                </v-btn>
              </v-col>
            </v-row>

            <v-divider class="my-5" />

            <v-row class="text-center">
              <v-col cols="12" class="text-body-2 text-medium-emphasis">
                Vous vous en souvenez ?
                <router-link
                  to="/login"
                  class="text-primary font-weight-bold text-decoration-none ml-1 link-hover"
                >
                  Se connecter
                </router-link>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { useRepo } from 'pinia-orm'
import { UserRepo } from '@/models/User'
import { useToast } from 'vue-toastification'
import logoImg from '@/assets/logo.png'

export default {
  name: 'ForgottenPwdView',
  beforeRouteEnter: function(to, from, next) {
    document.body.classList.add('login')
    next()
  },
  beforeRouteLeave: function(to, from, next) {
    document.body.classList.remove('login')
    next()
  },
  data: () => ({
    username: '',
    password: '',
    sending: false,
    displayConfirm: false,
    logo: logoImg
  }),
  methods: {
    renew: async function () {
      try {
        this.sending = true
        this.displayConfirm = false
        const newPwd = await useRepo(UserRepo).$forgottenPassword(this.username)
        this.sending = false
        this.displayConfirm = true
      }
      catch(e) {
        this.sending = false
        const toast = useToast()
        toast('Nous n\'avons pas pu trouver cet utilisateur...', {
          type: 'error'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.centerPlace {
  max-width: 480px;
}

.link-hover {
  transition: opacity 0.2s ease;
  &:hover {
    text-decoration: underline !important;
    opacity: 0.85;
  }
}
</style>